
    <template>
      <section class="relax-doc">
        <h1>Scroll 滚动</h1>
<blockquote>
<p>比原生浏览器更漂亮的滚动条</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>可以设置 <code>height</code> 控制滚动区域的高度</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-scroll :height=&quot;250&quot;&gt;
    &lt;div class=&quot;demo-scroll-item&quot; v-for=&quot;item in 10&quot;&gt;{{item}}&lt;/div&gt;
  &lt;/x-scroll&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="chu-fa-shi-jian"><a class="header-anchor" href="#chu-fa-shi-jian"></a> 触发事件</h2>
<blockquote>
<p><code>onScroll</code> 事件可以知道当前滚动的比值，从而实现业务逻辑</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;handleClick(true)&quot;&gt;添加内容&lt;/x-button&gt;
  &lt;x-button type=&quot;danger&quot; plain @click=&quot;handleClick(false)&quot;&gt;减少内容&lt;/x-button&gt;
  &lt;x-scroll :height=&quot;250&quot; @onScroll=&quot;scroll&quot;&gt;
    &lt;div class=&quot;demo-scroll-item&quot; v-for=&quot;item in count&quot;&gt;{{item}}&lt;/div&gt;
  &lt;/x-scroll&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance, ref} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const count = ref(3)

      const scroll = (val) =&gt; {
        if(val === 0){
          $message('到顶部了')
        } else if(val === 1) {
          $message('到底部了')
        }
      }

      const handleClick = (val) =&gt; {
        if(val){
          count.value += 3
        } else {
          count.value -= 3
          count.value = count.value &lt; 0 ? 0 : count.value 
        }
      }

      return {
        scroll,
        count,
        handleClick
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="gun-dong-dao-zhi-ding-zuo-biao"><a class="header-anchor" href="#gun-dong-dao-zhi-ding-zuo-biao"></a> 滚动到指定坐标</h2>
<blockquote>
<p><code>v-model:to</code> 是一个双向绑定的值，用于控制滚动到指定的坐标</p>
</blockquote>
<demo-block>
        <p><code>alwaysVisible</code> 是否隐藏滚动条,默认 <code>true</code></p>

        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;to = 500&quot;&gt;滚动到 500&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;to = 1200&quot;&gt;滚动到 1200&lt;/x-button&gt;
  &lt;x-badge :count=&quot;to&quot; /&gt;

  &lt;x-scroll :height=&quot;250&quot; v-model:to=&quot;to&quot;  :alwaysVisible=&quot;false&quot;&gt;
    &lt;div class=&quot;demo-scroll-item&quot; v-for=&quot;item in 50&quot;&gt;{{item}}&lt;/div&gt;
  &lt;/x-scroll&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance, ref} from 'vue'
  export default {
    setup(){
      const to = ref(0)

      return {
        to,
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="wu-xian-gun-dong"><a class="header-anchor" href="#wu-xian-gun-dong"></a> 无限滚动</h2>
<blockquote>
<p>在滚动条 <code>80%</code> 的位置开始追加内容</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-scroll :height=&quot;250&quot; @onScroll=&quot;scroll&quot;&gt;
    &lt;div class=&quot;demo-scroll-item&quot; v-for=&quot;item in count&quot;&gt;{{item}}&lt;/div&gt;
  &lt;/x-scroll&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance, ref} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties

      const count = ref(4)

      const scroll = (val) =&gt; {
        if(val &gt;= 0.8){
            count.value += 3
        }
      }
      return {
        scroll,
        count
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, createElementVNode: _createElementVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_scroll = _resolveComponent("x-scroll")

  return (_openBlock(), _createBlock(_component_x_scroll, { height: 250 }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (item) => {
        return _createElementVNode("div", { class: "demo-scroll-item" }, _toDisplayString(item), 1)
      }), 64))
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_scroll = _resolveComponent("x-scroll")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.handleClick(true))
    }, {
      default: _withCtx(() => [
        _createTextVNode("添加内容")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "danger",
      plain: "",
      onClick: $event => (_ctx.handleClick(false))
    }, {
      default: _withCtx(() => [
        _createTextVNode("减少内容")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_scroll, {
      height: 250,
      onOnScroll: _ctx.scroll
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
          return (_openBlock(), _createElementBlock("div", { class: "demo-scroll-item" }, _toDisplayString(item), 1))
        }), 256))
      ]),
      _: 1
    }, 8, ["onOnScroll"])
  ], 64))
}
  
    
        const {getCurrentInstance, ref} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const count = ref(3)

      const scroll = (val) => {
        if(val === 0){
          $message('到顶部了')
        } else if(val === 1) {
          $message('到底部了')
        }
      }

      const handleClick = (val) => {
        if(val){
          count.value += 3
        } else {
          count.value -= 3
          count.value = count.value < 0 ? 0 : count.value 
        }
      }

      return {
        scroll,
        count,
        handleClick
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, createElementVNode: _createElementVNode } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")
  const _component_x_badge = _resolveComponent("x-badge")
  const _component_x_scroll = _resolveComponent("x-scroll")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.to = 500)
    }, {
      default: _withCtx(() => [
        _createTextVNode("滚动到 500")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: $event => (_ctx.to = 1200)
    }, {
      default: _withCtx(() => [
        _createTextVNode("滚动到 1200")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_badge, { count: _ctx.to }, null, 8, ["count"]),
    _createVNode(_component_x_scroll, {
      height: 250,
      to: _ctx.to,
      "onUpdate:to": $event => ((_ctx.to) = $event),
      alwaysVisible: false
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(50, (item) => {
          return _createElementVNode("div", { class: "demo-scroll-item" }, _toDisplayString(item), 1)
        }), 64))
      ]),
      _: 1
    }, 8, ["to", "onUpdate:to"])
  ], 64))
}
  
    
        const {getCurrentInstance, ref} = Vue
        
  const democomponentExport = {
    setup(){
      const to = ref(0)

      return {
        to,
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, resolveComponent: _resolveComponent, withCtx: _withCtx, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_scroll = _resolveComponent("x-scroll")

  return (_openBlock(), _createBlock(_component_x_scroll, {
    height: 250,
    onOnScroll: _ctx.scroll
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
        return (_openBlock(), _createElementBlock("div", { class: "demo-scroll-item" }, _toDisplayString(item), 1))
      }), 256))
    ]),
    _: 1
  }, 8, ["onOnScroll"]))
}
  
    
        const {getCurrentInstance, ref} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties

      const count = ref(4)

      const scroll = (val) => {
        if(val >= 0.8){
            count.value += 3
        }
      }
      return {
        scroll,
        count
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  